import { FactsLakeApiSDK } from '@tech-insights/facts-lake-sdk';
import { TechInsightsApiConfig } from '@mercedes-benz/tech-insights-common';
import { TechInsightsProvidersRunnerApiSDK } from '@tech-insights/providers-runner-sdk';
import { TechStackApiSDK } from '@tech-insights/tech-stack-sdk';
import { TechInsightsContractsApiSDK } from '@tech-insights/contracts-sdk';
import { WorkflowsSDK } from '@tech-insights/workflows-sdk';

export class ApiFactory {
  static createContractsApi(config: TechInsightsApiConfig) {
    const builder = TechInsightsContractsApiSDK.configure({
      baseURL: `${config.apiBaseUrl}/contracts`,
    });
    if (config.axiosPlugin) builder.enablePlugin(config.axiosPlugin);
    return builder.connect();
  }

  static createWorkflowsApi(config: TechInsightsApiConfig) {
    const builder = WorkflowsSDK.configure({
      baseURL: `${config.apiBaseUrl}/workflows`,
    });
    if (config.axiosPlugin) builder.enablePlugin(config.axiosPlugin);
    return builder.connect();
  }

  static createFactsLakeApi(config: TechInsightsApiConfig) {
    const builder = FactsLakeApiSDK.configure({
      baseURL: `${config.apiBaseUrl}/lake`,
    });
    if (config.axiosPlugin) builder.enablePlugin(config.axiosPlugin);
    return builder.connect();
  }

  static createProvidersRunnerApi(config: TechInsightsApiConfig) {
    const builder = TechInsightsProvidersRunnerApiSDK.configure({
      baseURL: `${config.apiBaseUrl}/providers`,
    });
    if (config.axiosPlugin) builder.enablePlugin(config.axiosPlugin);
    return builder.connect();
  }

  static createTechStackApi(config: TechInsightsApiConfig) {
    const builder = TechStackApiSDK.configure({
      baseURL: `${config.apiBaseUrl}/tech-stack`,
    });
    if (config.axiosPlugin) builder.enablePlugin(config.axiosPlugin);
    return builder.connect();
  }
}
